/* petioz-cart.js — AJAX add-to-cart for every [data-ptz-atc] button */
(function () {
  if (window.__ptzCartBound) return;
  window.__ptzCartBound = true;

  function addToCart(variantId, btn) {
    var props = {};
    document.querySelectorAll('[data-ptz-prop]').forEach(function (input) {
      if (input.value) props[input.getAttribute('data-ptz-prop')] = input.value;
    });
    var item = { id: variantId, quantity: 1 };
    if (Object.keys(props).length) item.properties = props;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var drawer = document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      var opener = document.querySelector('[data-cart-drawer-open], .header__icon--cart');
      if (opener && opener.tagName !== 'A') { opener.click(); return; }
      window.location.href = '/cart';
    }).catch(function () {
      window.location.href = '/cart';
    }).finally(function () {
      if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ptz-atc]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    btn.style.opacity = '.7';
    addToCart(id, btn);
  });
})();
